// src/modules/app-views/services/pages/Document/actions/menuButton.js

import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownNew,
  dropdownParameters,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

const servicesDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
      dropdownDivider,
      dropdownParameters,
    ],
  };
};

export default servicesDocumentMenuButton;
